/* Statická část inline skriptů ze sections/product-tabs.liquid.
   Dynamické hodnoty (section.id, překlady) přicházejí přes
   window.__tkProductTabs, které sekce nastavuje inline těsně nad
   <script src>. Pořadí IIFE odpovídá původnímu pořadí <script> bloků. */
  // Náhled recenzí pod taby (sections/tk-reviews-preview.liquid) se schová,
  // když je otevřený tab Recenze — jinak jsou tytéž recenze na stránce dvakrát
  // (widget v tabu + náhled hned pod ním). Volá se při každém přepnutí tabu
  // i po přerenderu sekce (změna varianty).
  function tkSyncReviewsPreview() {
    var open = !!document.querySelector('.product-tabs__tab.active[data-tab-name="reviews"]');
    document.querySelectorAll('.tk-reviews-preview').forEach(function(el) {
      el.classList.toggle('tk-reviews-preview--tab-open', open);
    });
  }
  (function() {
    var section = document.currentScript.closest('.product-tabs') || document.querySelector('.product-tabs');
    if (!section) return;

    function smoothScrollTo(el) {
      var headerH = document.querySelector('.tk-header')?.offsetHeight || 0;
      var targetY = el.getBoundingClientRect().top + window.scrollY - headerH - 20;
      var startY = window.scrollY;
      var diff = targetY - startY;
      if (Math.abs(diff) < 10) return;
      var duration = 500;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        window.scrollTo(0, startY + diff * ease);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var tabs = section.querySelectorAll('.product-tabs__tab');
    var panels = section.querySelectorAll('.product-tabs__panel');
    var navWrap = section.querySelector('.product-tabs__nav-wrap');
    var navEl = section.querySelector('.product-tabs__nav');

    function scrollTabIntoView(tab) {
      if (!navEl || !tab) return;
      var nav = navEl.getBoundingClientRect();
      var t = tab.getBoundingClientRect();
      // Offset tab so it's fully visible with a bit of breathing room on each side.
      var pad = 24;
      if (t.left < nav.left + pad) {
        navEl.scrollBy({ left: t.left - nav.left - pad, behavior: 'smooth' });
      } else if (t.right > nav.right - pad) {
        navEl.scrollBy({ left: t.right - nav.right + pad, behavior: 'smooth' });
      }
    }

    // Vycentruje kliknutý tab v liště, ať jsou vidět i následující taby za ním.
    function centerTab(tab) {
      if (!navEl || !tab) return;
      if (navEl.scrollWidth <= navEl.clientWidth + 1) return; // nic se neroluje
      var nav = navEl.getBoundingClientRect();
      var t = tab.getBoundingClientRect();
      var delta = (t.left - nav.left) - (nav.width - t.width) / 2;
      var target = navEl.scrollLeft + delta;
      var max = navEl.scrollWidth - navEl.clientWidth;
      if (target < 0) target = 0;
      if (target > max) target = max;
      navEl.scrollTo({ left: target, behavior: 'smooth' });
    }

    function updateOverflowState() {
      if (!navWrap || !navEl) return;
      var overflowing = navEl.scrollWidth > navEl.clientWidth + 1;
      navWrap.classList.toggle('is-overflowing', overflowing);
      var atEnd = navEl.scrollLeft + navEl.clientWidth >= navEl.scrollWidth - 2;
      navWrap.classList.toggle('is-at-end', atEnd);
    }

    if (navEl) {
      navEl.addEventListener('scroll', updateOverflowState, { passive: true });
      window.addEventListener('resize', updateOverflowState);
      requestAnimationFrame(updateOverflowState);
      // Při loadu scrollni aktivní tab do view (užitečné když je default úplně vpravo)
      var initialActive = navEl.querySelector('.product-tabs__tab.active');
      if (initialActive) requestAnimationFrame(function() { scrollTabIntoView(initialActive); });
    }

    // Deep-link tabů přes hash v URL (#params, #downloads, …). Jména jsou
    // locale-nezávislá (data-tab-name), takže odkaz funguje i na EN/SK verzi.
    function setTabHash(name) {
      if (!name || !window.history || !history.replaceState) return;
      // replaceState, ne push — proklikávání tabů nesmí zaplevelit historii
      // (jinak by uživatel musel mačkat Zpět tolikrát, kolik tabů otevřel).
      history.replaceState(null, '', window.location.pathname + window.location.search + '#' + name);
    }

    function activateTab(tab, opts) {
      if (!tab) return;
      opts = opts || {};
      var idx = tab.getAttribute('data-tab');
      tabs.forEach(function(t) { t.classList.remove('active'); });
      panels.forEach(function(p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var target = section.querySelector('[data-panel="' + idx + '"]');
      if (target) target.classList.add('active');
      tkSyncReviewsPreview();
      centerTab(tab);
      if (opts.updateHash !== false) setTabHash(tab.dataset.tabName);
      if (opts.scroll) smoothScrollTo(section);
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() { activateTab(this); });
    });

    // Hash → otevřený tab. Vrací true, když hash na nějaký tab sedí.
    function applyTabHash(scroll) {
      var name = (window.location.hash || '').slice(1);
      try { name = decodeURIComponent(name); } catch (e) {}
      if (!name) return false;
      var tab = section.querySelector('.product-tabs__tab[data-tab-name="' + name + '"]');
      if (!tab) return false;
      activateTab(tab, { updateHash: false, scroll: !!scroll });
      return true;
    }

    tkSyncReviewsPreview(); // výchozí stav (bez hashe se activateTab nevolá)
    if (window.location.hash && applyTabHash(false)) {
      // Scroll až po loadu — dřív jsou obrázky/fonty nedopočítané a trefí se vedle.
      window.addEventListener('load', function() {
        setTimeout(function() { smoothScrollTo(section); }, 100);
      });
    }
    // Zpět/vpřed v prohlížeči i kliknutí na odkaz s hashem na téže stránce
    window.addEventListener('hashchange', function() { applyTabHash(true); });
  })();

  (function() {
    var sectionId = (window.__tkProductTabs || {}).sectionId;
    function updateTabs(doc) {
      var sectionSel = '#shopify-section-' + sectionId;
      var oldInner = document.querySelector(sectionSel + ' .product-tabs__inner');
      var newInner = doc.querySelector(sectionSel + ' .product-tabs__inner') || doc.querySelector('.product-tabs__inner');
      if (!oldInner || !newInner) return false;

      // Remember which tab was active (by name if possible, otherwise index)
      var activeTab = oldInner.querySelector('.product-tabs__tab.active');
      var activeTabName = activeTab && activeTab.dataset.tabName;
      var activeTabIdx = activeTab && activeTab.dataset.tab;

      // Update nav (tab buttons) — replace entirely so tabs appear/disappear correctly
      var oldNav = oldInner.querySelector('.product-tabs__nav');
      var newNav = newInner.querySelector('.product-tabs__nav');
      if (oldNav && newNav) {
        oldNav.innerHTML = newNav.innerHTML;
      } else if (!oldNav && newNav) {
        oldInner.insertBefore(newNav.cloneNode(true), oldInner.firstChild);
      } else if (oldNav && !newNav) {
        oldNav.remove();
      }

      // Match panels by name (features, params) — not by index
      var panelNames = ['features', 'params'];
      panelNames.forEach(function(name) {
        var oldPanel = oldInner.querySelector('[data-panel-name="' + name + '"]');
        var newPanel = newInner.querySelector('[data-panel-name="' + name + '"]');
        if (oldPanel && newPanel) {
          oldPanel.innerHTML = newPanel.innerHTML;
        } else if (!oldPanel && newPanel) {
          var refPanel = oldInner.querySelector('.product-tabs__panel');
          if (refPanel) {
            refPanel.parentNode.insertBefore(newPanel.cloneNode(true), refPanel);
          }
        } else if (oldPanel && !newPanel) {
          oldPanel.remove();
        }
      });

      // Re-index panels and tabs
      var panels = oldInner.querySelectorAll('.product-tabs__panel');
      var tabs = oldInner.querySelectorAll('.product-tabs__tab');
      panels.forEach(function(p, i) { p.dataset.panel = i; });
      tabs.forEach(function(t, i) { t.dataset.tab = i; });

      // Restore active tab (prefer by name, fallback to index 0)
      tabs.forEach(function(t) { t.classList.remove('active'); });
      panels.forEach(function(p) { p.classList.remove('active'); });
      var restored = false;
      if (activeTabName) {
        tabs.forEach(function(t) {
          if (t.dataset.tabName === activeTabName) {
            t.classList.add('active');
            var p = oldInner.querySelector('[data-panel="' + t.dataset.tab + '"]');
            if (p) p.classList.add('active');
            restored = true;
          }
        });
      }
      if (!restored && tabs.length > 0) {
        tabs[0].classList.add('active');
        if (panels[0]) panels[0].classList.add('active');
      }

      // Re-bind tab click handlers
      var reNavEl = oldInner.querySelector('.product-tabs__nav');
      function reCenterTab(tab) {
        if (!reNavEl || !tab) return;
        if (reNavEl.scrollWidth <= reNavEl.clientWidth + 1) return;
        var nav = reNavEl.getBoundingClientRect();
        var r = tab.getBoundingClientRect();
        var target = reNavEl.scrollLeft + (r.left - nav.left) - (nav.width - r.width) / 2;
        var max = reNavEl.scrollWidth - reNavEl.clientWidth;
        if (target < 0) target = 0;
        if (target > max) target = max;
        reNavEl.scrollTo({ left: target, behavior: 'smooth' });
      }
      tabs.forEach(function(t) {
        t.onclick = function() {
          tabs.forEach(function(b) { b.classList.remove('active'); });
          panels.forEach(function(p) { p.classList.remove('active'); });
          t.classList.add('active');
          var target = oldInner.querySelector('[data-panel="' + t.dataset.tab + '"]');
          if (target) target.classList.add('active');
      tkSyncReviewsPreview();
          reCenterTab(t);
          // Drž hash v URL i po přerenderu sekce (změna varianty)
          if (t.dataset.tabName && window.history && history.replaceState) {
            history.replaceState(null, '', window.location.pathname + window.location.search + '#' + t.dataset.tabName);
          }
        };
      });

      // Show/hide section
      var sectionEl = document.querySelector(sectionSel + ' .product-tabs');
      var newSection = doc.querySelector(sectionSel + ' .product-tabs') || doc.querySelector('.product-tabs');
      if (sectionEl && newSection) {
        sectionEl.style.display = newSection.style.display || '';
      }

      // Force reveal on feature blocks — innerHTML wipes is-visible class
      // and IntersectionObserver already disconnected from old elements
      oldInner.querySelectorAll('.feature-block, .feature-block--video-full').forEach(function(b) {
        b.classList.add('is-visible');
      });
      tkSyncReviewsPreview();
      // Před/po slidery v novém DOMu potřebují znovu navěsit „hint" observer
      document.dispatchEvent(new CustomEvent('tk:product-tabs-updated'));
      return true;
    }

    function fetchAndUpdateTabs(variantId) {
      if (!variantId) return;
      var url = window.location.pathname + '?variant=' + variantId + '&sections=' + sectionId;
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(json) {
          var sectionHtml = json[sectionId];
          if (!sectionHtml) return;
          var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          updateTabs(doc);
        })
        .catch(function() {});
    }

    // Use HTML from variant event — fallback to separate fetch if HTML
    // doesn't contain tabs section (e.g. variant-picker now uses section_id=main
    // which doesn't include the product-tabs section).
    document.addEventListener('variant:update', function(e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      var variant = e.detail && e.detail.resource;
      if (html) {
        var updated = updateTabs(html);
        if (updated) return;
      }
      if (variant && variant.id) fetchAndUpdateTabs(variant.id);
    });
  })();

  // Judge.me preview badge click → switch to Reviews tab + scroll
  (function() {
    document.addEventListener('click', function(e) {
      // Only handle clicks on preview badge stars, NOT modal stars
      if (e.target.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal')) return;
      var badge = e.target.closest('.jdgm-prev-badge, [data-jdgm-preview-badge], .jdgm-star, .jdgm-preview-badge');
      if (!badge) return;
      e.preventDefault();
      e.stopPropagation();

      // Find Reviews tab button (data-tab-name="reviews" — locale-independent)
      var reviewTab = document.querySelector('.product-tabs__tab[data-tab-name="reviews"]');
      if (reviewTab) {
        reviewTab.click();
        setTimeout(function() {
          var section = document.querySelector('.product-tabs');
          if (!section) return;
          var headerH = document.querySelector('.tk-header')?.offsetHeight || 0;
          var targetY = section.getBoundingClientRect().top + window.scrollY - headerH - 20;
          var startY = window.scrollY;
          var diff = targetY - startY;
          var duration = 600;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            window.scrollTo(0, startY + diff * ease);
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, 150);
      }
    }, true);
  })();

  // Judge.me reviewer info polish: formát data, verified badge → fajfka v kolečku
  // s tooltipem, „Anonymní" → „Anonymous" na EN locale (jméno je uložené ve review
  // datech v CS, Judge.me ho nepřekládá). Struktura widgetu se ZACHOVÁVÁ — dřívější
  // fixDates flattenoval innerHTML přes textContent → „AnonymníOvěřeno" bez mezery.
  (function() {
    var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false">'
      + '<circle cx="7" cy="7" r="7" fill="#CED720"/>'
      + '<path d="M4 7.3 6.1 9.4 10 5.1" fill="none" stroke="#0A0A0A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>';

    function fixReviewerInfo() {
      // 1) datum dd/mm/yyyy → dd.mm.yyyy (jen text date spanu, struktura netknutá)
      document.querySelectorAll('.jm-reviewer-info__details .jm-text').forEach(function(el) {
        if (el.getAttribute('data-date-fixed') || el.children.length) return;
        var t = el.textContent;
        if (/^\s*\d{2}\/\d{2}\/\d{4}\s*$/.test(t)) {
          el.textContent = t.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3').trim();
          el.setAttribute('data-date-fixed', '1');
        }
      });
      // 2) Verified badge → fajfka v kolečku, tooltip = původní text (Ověřeno/Verified)
      document.querySelectorAll('.jm-verified-buyer-badge').forEach(function(b) {
        if (b.getAttribute('data-tk-verified')) return;
        var label = (b.textContent || '').trim() || (window.__tkProductTabs || {}).verifiedLabel;
        b.setAttribute('data-tk-verified', '1');
        b.setAttribute('data-tk-tip', label);
        b.setAttribute('aria-label', label);
        b.classList.add('tk-verified-badge');
        b.innerHTML = CHECK_SVG;
      });
      // 3) „Anonymní" ve jménu na EN locale
      if (isEn) {
        document.querySelectorAll('.jm-reviewer-info__name').forEach(function(n) {
          if (n.textContent.trim() === 'Anonymní') {
            n.textContent = 'Anonymous';
            n.setAttribute('title', 'Anonymous');
          }
        });
      }
      // 4) Průměr „5.0" → „5,0" mimo EN (Judge.me renderuje desetinnou tečku vždy)
      if (!isEn) {
        document.querySelectorAll('.jm-average-rating-display .jm-text, .jm-review-widget-header__average-rating-display .jm-text').forEach(function(el) {
          if (el.children.length) return;
          var t = el.textContent;
          if (/^\s*\d+\.\d+\s*$/.test(t)) el.textContent = t.replace('.', ',');
        });
      }
      // 5) „Recenze pro" i u recenzí na VLASTNÍ produkt. Judge.me ve skupinových
      //    recenzích kreslí .jm-product-variant-card jen u recenze na JINÝ produkt
      //    ze skupiny (is_for_product_from_group), takže v mřížce to bylo někde a
      //    někde ne. Doplníme stejný blok s aktuálním produktem (data z Liquidu
      //    v window.__tkProductTabs.reviewFor). Idempotentní: karta s blokem se přeskočí.
      var cfg = (window.__tkProductTabs || {}).reviewFor;
      if (cfg && cfg.url) {
        var esc = function(str) { return String(str || '').replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        document.querySelectorAll('#judgeme_product_reviews .jm-review-item').forEach(function(item) {
          if (item.querySelector('.jm-product-variant-card')) return;
          var stack = item.firstElementChild;
          if (!stack || !stack.classList.contains('jm-stack')) return;
          var card = document.createElement('div');
          card.className = 'jm-box jm-box--inherit-color jm-product-variant-card tk-own-variant-card';
          card.innerHTML = '<div class="jm-cluster">'
            + '<a class="jm-frame jm-product-variant-card__thumbnail" href="' + esc(cfg.url) + '" aria-label="' + esc(cfg.title) + '">'
            + (cfg.image ? '<img src="' + esc(cfg.image) + '" alt="" loading="lazy" width="30" height="30">' : '')
            + '</a>'
            + '<div class="jm-stack jm-stack--space-0 jm-product-variant-card__content">'
            + '<p class="jm-text">' + esc(cfg.label) + '</p>'
            + '<a class="jm-text jm-product-variant-card__product-link" href="' + esc(cfg.url) + '">' + esc(cfg.title) + '</a>'
            + '</div></div>';
          stack.appendChild(card);
        });
      }
      // legacy jdgm widget timestamp
      document.querySelectorAll('.jdgm-rev__timestamp').forEach(function(el) {
        if (el.getAttribute('data-date-fixed')) return;
        var text = el.textContent;
        if (text.match(/\d{2}\/\d{2}\/\d{4}/)) {
          el.textContent = text.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, '$1.$2.$3');
          el.setAttribute('data-date-fixed', '1');
        }
      });
    }
    setTimeout(fixReviewerInfo, 2000);
    setTimeout(fixReviewerInfo, 5000);
    // Re-run při re-renderu widgetu (paginace recenzí, lazy load) — idempotentní
    // přes data atributy, vlastní mutace se přeskočí, žádný infinite loop.
    var jw = document.getElementById('judgeme_product_reviews');
    if (jw && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function() { fixReviewerInfo(); }).observe(jw, { childList: true, subtree: true });
    }
  })();

  // Judge.me reviews masonry: CSS grid natahuje karty v řádku na výšku nejdelší
  // recenze (2 krátké vedle 1 dlouhé = velké prázdné plochy). Tady každá karta
  // dostane `grid-row-end: span <výška + mezera>` nad 1px řádky (.tk-masonry
  // v tk-product-tabs.css), takže se skládají těsně pod sebe. ResizeObserver
  // pokrývá všechno: otevření tabu (výšky 0 → skutečné), fonty, obrázky,
  // rozbalení odpovědi obchodu i změnu šířky okna; MutationObserver jen
  // přihlásí nové karty po paginaci/řazení. Nastavení spanu výšku karty
  // nemění (align-items: start), takže observer nezacyklí.
  (function() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root || typeof ResizeObserver === 'undefined' || typeof MutationObserver === 'undefined') return;
    var GAP = 22;
    var raf = 0;
    var ro = new ResizeObserver(schedule);

    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function() { raf = 0; layout(); });
    }

    function layout() {
      var list = root.querySelector('.jdgm-review-list');
      if (!list) return;
      var items = Array.prototype.filter.call(list.children, function(el) { return el.classList.contains('jm-review-item'); });
      var cols = getComputedStyle(list).gridTemplateColumns.split(' ').length;
      var heights = items.map(function(it) { return it.getBoundingClientRect().height; });
      var visible = heights.some(function(h) { return h > 0; });
      if (cols < 2) {
        list.classList.remove('tk-masonry');
        items.forEach(function(it) { if (it.style.gridRowEnd) it.style.gridRowEnd = ''; });
        return;
      }
      if (!visible) return;
      list.classList.add('tk-masonry');
      items.forEach(function(it, i) {
        var v = 'span ' + (Math.ceil(heights[i]) + GAP);
        if (it.style.gridRowEnd !== v) it.style.gridRowEnd = v;
      });
    }

    function observeAll() {
      var list = root.querySelector('.jdgm-review-list');
      if (!list) return;
      ro.observe(list);
      Array.prototype.forEach.call(list.children, function(el) { ro.observe(el); });
      schedule();
    }

    observeAll();
    new MutationObserver(observeAll).observe(root, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
  })();

  // Aktivní hvězdičkový filtr Judge.me: histogram JE filtr. Judge.me po kliknutí
  // na řádek histogramu vloží do hlavičky panel s <label .jm-rating-filter__tag
  // --selected> (panel je v CSS skrytý, tlačítko „Filtry" taky) a řádek histogramu
  // sám žádný stav nedostane. Tady se podle vybraného tagu: (1) označí řádek
  // .tk-hist-active + .tk-has-filter na .jm-histogram (ostatní řádky CSS ztlumí),
  // (2) pod histogram dopíše věta „Zobrazeny jen recenze s hodnocením N ★ ·
  // Zrušit filtr" (texty z window.__tkProductTabs.reviewsFilter, tlačítko klikne
  // na skrytý „Vymazat filtry" Judge.me), (3) prázdný výsledek dostane náš text.
  // Zavření panelu filtr RUŠÍ (ověřeno), takže bez tagů v DOMu se vše odebere.
  // Idempotentní — mění DOM jen při rozdílu, ať vlastní mutace observer nezacyklí.
  (function() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root || typeof MutationObserver === 'undefined') return;
    var i18n = (window.__tkProductTabs || {}).reviewsFilter || {};

    function selectedValue() {
      var value = '';
      root.querySelectorAll('.jm-rating-filter__tag').forEach(function(t) {
        var input = t.querySelector('input');
        if (t.classList.contains('jm-rating-filter__tag--selected') || (input && input.checked)) {
          value = (input && input.value) || t.textContent.replace(/\D/g, '');
        }
      });
      return value;
    }

    function clearFilter() {
      var clear = root.querySelector('.jm-filter-panel__clear-btn');
      if (clear) { clear.click(); return; }
      var btn = root.querySelector('.jm-custom-answer-filter[aria-expanded="true"]');
      if (btn) btn.click();
    }

    function ensureStatus(header) {
      var el = header.querySelector('.tk-jm-filter-status');
      if (el) return el;
      el = document.createElement('p');
      el.className = 'tk-jm-filter-status';
      el.hidden = true;
      var text = document.createElement('span');
      text.className = 'tk-jm-filter-status__text';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tk-jm-filter-status__clear';
      btn.textContent = i18n.clear || 'Zrušit filtr';
      btn.addEventListener('click', clearFilter);
      el.appendChild(text);
      el.appendChild(btn);
      header.appendChild(el);
      return el;
    }

    function sync() {
      var header = root.querySelector('.jm-review-widget-header');
      if (!header) return;
      var value = selectedValue();
      var on = !!value;
      root.querySelectorAll('.jm-histogram').forEach(function(h) {
        if (h.classList.contains('tk-has-filter') !== on) h.classList.toggle('tk-has-filter', on);
      });
      root.querySelectorAll('.jm-histogram-row').forEach(function(row) {
        var num = row.querySelector('.jm-histogram-row__rating');
        var active = on && !!num && num.textContent.trim() === value;
        if (row.classList.contains('tk-hist-active') !== active) row.classList.toggle('tk-hist-active', active);
      });
      var status = ensureStatus(header);
      if (on) {
        var text = (i18n.active || 'Zobrazeny jen recenze s hodnocením __R__ ★').replace('__R__', value);
        var span = status.querySelector('.tk-jm-filter-status__text');
        if (span.textContent !== text) span.textContent = text;
      }
      if (status.hidden !== !on) status.hidden = !on;
      if (i18n.empty) {
        root.querySelectorAll('.jdgm-empty-state .jm-text').forEach(function(p) {
          if (p.textContent !== i18n.empty) p.textContent = i18n.empty;
        });
      }
    }

    new MutationObserver(sync).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
  })();

  // Add stars next to average rating number
  (function() {
    function addStarsToRating() {
      var avgDisplay = document.querySelector('.reviews-tab .jm-average-rating-display');
      if (!avgDisplay || avgDisplay.querySelector('.tk-avg-stars')) return;
      var ratingText = avgDisplay.querySelector('.jm-text[style*="bold"]');
      if (!ratingText) return;
      // replace: fixReviewerInfo mohl už přepsat „5.0" na „5,0" (parseFloat by u „4,8" vrátil 4)
      var rating = parseFloat(ratingText.textContent.replace(',', '.'));
      if (isNaN(rating)) return;
      var starsHtml = '<span class="tk-avg-stars" style="display:inline-flex;gap:2px;margin-left:8px;vertical-align:middle;">';
      for (var i = 1; i <= 5; i++) {
        var fill = i <= Math.round(rating) ? '#CED720' : '#e0e0e0';
        starsHtml += '<svg width="16" height="16" viewBox="0 0 24 24" fill="' + fill + '" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
      }
      starsHtml += '</span>';
      ratingText.insertAdjacentHTML('afterend', starsHtml);
    }
    // Run after Judge.me loads
    var observer = new MutationObserver(function() { addStarsToRating(); });
    var tab = document.querySelector('.reviews-tab');
    if (tab) observer.observe(tab, { childList: true, subtree: true });
    setTimeout(addStarsToRating, 2000);
  })();

  // Judge.me modal (napsat recenzi / detail) → zamknout scroll stránky na pozadí.
  // Judge.me vlastní scroll-lock nemá; replikujeme theme pattern z dialog.js
  // (position:fixed na body + obnova scroll pozice po zavření).
  (function() {
    var MODAL_SEL = '.jdgm-write-review-modal, .jdgm-review-widget-modal';
    var locked = false;
    var savedY = 0;
    function visible(el) {
      if (!el) return false;
      var s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
      return el.offsetParent !== null || s.position === 'fixed';
    }
    function modalOpen() {
      var els = document.querySelectorAll(MODAL_SEL);
      for (var i = 0; i < els.length; i++) { if (visible(els[i])) return true; }
      return false;
    }
    function sync() {
      var open = modalOpen();
      if (open && !locked) {
        savedY = window.scrollY;
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + savedY + 'px';
        locked = true;
      } else if (!open && locked) {
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({ top: savedY, behavior: 'instant' });
        locked = false;
      }
    }
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(sync).observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
      });
    }
    // close button / overlay klik — mutace nemusí stačit, dosync po kliku
    document.addEventListener('click', function() { setTimeout(sync, 50); }, true);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') setTimeout(sync, 50);
    }, true);
  })();


  // Feature blocks scroll-reveal animation
  (function() {
    var blocks = document.querySelectorAll('.feature-block, .feature-block--video-full');
    if (!blocks.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Stagger animation for left/right elements
            var el = entry.target;
            var delay = 0;
            var idx = Array.from(blocks).indexOf(el);
            if (idx > 0) delay = 100;

            setTimeout(function() {
              el.classList.add('is-visible');
            }, delay);
            observer.unobserve(el);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

      blocks.forEach(function(block) {
        observer.observe(block);
      });
    } else {
      // Fallback: show all immediately
      blocks.forEach(function(block) { block.classList.add('is-visible'); });
    }
  })();

  /* Před/po slider — delegované ovládání, funguje i po variant swapu (výměna innerHTML) */
  (function () {
    if (window.__tkCompareInit) return;
    window.__tkCompareInit = true;

    /*
      ⚠️⚠️ Tah řídí NATIVNÍ `<input type="range">` přes celý rámec, ne vlastní
      pointer handling. Prohlížeč si tažení thumbu obsluhuje sám a `input`
      posílá zarovnaně s vykreslováním, takže nevzniká jitter z nesouladu
      vzorkování myši (~125 Hz) a snímků (60 Hz). Vlastní přepočet z
      `pointermove` tenhle jitter naopak přenášel na obrazovku a žádné
      throttlování ani vyhlazování ho neumělo skrýt — jen přidávalo latenci.
      Referenční implementace (therashop.cz) to dělá stejně a je plynulá i s
      `clip-path`/`left`, tedy bez GPU triků níž. Vstup byl vždy ten problém.

      Zbylo tu jen: `input` → ořez + čára, hint a jeho zhasnutí.
      ŽÁDNÝ pointerdown/pointermove/pointerup, žádný rAF loop.
    */
    var paintedPct = -1;

    /*
      Zápis je inline (`clipPath` na „po" vrstvě, `left` na čáře) — stejně jako
      v referenční implementaci. CSS varianta s `var(--tk-cmp-pos)` zůstává jako
      výchozí stav: respektuje `start_position` z metaobjektu i běh bez JS.
      Elementy cachované na rámci, `isConnected` kvůli variant swapu.
    */
    function elsFor(frame) {
      var els = frame.__tkCmpEls;
      if (!els || !els.after || !els.after.isConnected) {
        els = frame.__tkCmpEls = {
          after: frame.querySelector('.tk-cmp__after-wrap'),
          img: frame.querySelector('.tk-cmp__after-wrap .tk-cmp__img'),
          divider: frame.querySelector('.tk-cmp__divider')
        };
      }
      return els;
    }

    function paintPos(frame, pct) {
      var els = elsFor(frame);
      var fwd = 'translateX(' + pct + '%)';
      if (els.after) els.after.style.transform = fwd;
      if (els.img) els.img.style.transform = 'translateX(' + -pct + '%)';
      if (els.divider) els.divider.style.transform = fwd;
      paintedPct = pct;
    }

    function syncRange(frame, pct) {
      var range = frame.querySelector('.tk-cmp__range');
      if (range) range.value = pct; // step="any" → není potřeba zaokrouhlovat
    }

    function setPos(frame, pct) {
      pct = Math.max(0, Math.min(100, pct));
      paintPos(frame, pct);
      syncRange(frame, pct);
    }

    /*
      Jediný vstupní bod: `input` z nativního rangu (myš, dotyk, klávesnice
      i čtečky — všechno jednou cestou). Delegovaně na documentu, takže to
      přežije výměnu innerHTML při přepnutí varianty.
    */
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.classList || !t.classList.contains('tk-cmp__range')) return;
      var frame = t.closest('[data-tk-cmp-frame]');
      if (!frame) return;
      cancelHint(frame.closest('.tk-cmp')); // dojezd hintu by pozici přepsal
      paintPos(frame, parseFloat(t.value));
    });

    /*
      Jednorázové naznačení, že se s tím dá hýbat.
      ⚠️ Timeouty MUSÍ jít zrušit — když uživatel chytne slider během těch
      900 ms (typicky: doscrolluje k slideru a hned na něj sáhne), dojezd
      hintu by mu pozici přepsal zpět = viditelné poskočení uprostřed tahu.
    */
    var hintTimers = [];
    function cancelHint(wrap) {
      hintTimers.forEach(clearTimeout);
      hintTimers = [];
      if (wrap) wrap.classList.remove('is-hinting');
    }

    function hint(wrap) {
      if (wrap.dataset.tkCmpHinted) return;
      wrap.dataset.tkCmpHinted = '1';
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var frame = wrap.querySelector('[data-tk-cmp-frame]');
      if (!frame) return;
      var start = parseFloat(frame.querySelector('.tk-cmp__range').value) || 50;
      wrap.classList.add('is-hinting');
      setPos(frame, Math.min(100, start + 12));
      hintTimers.push(setTimeout(function () { setPos(frame, start); }, 900));
      hintTimers.push(setTimeout(function () { wrap.classList.remove('is-hinting'); }, 1900));
    }

    function observeAll() {
      var wraps = document.querySelectorAll('.tk-cmp:not([data-tk-cmp-hinted])');
      if (!wraps.length) return;
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hint(entry.target);
          io.unobserve(entry.target);
        });
      }, { threshold: 0.4 });
      wraps.forEach(function (w) { io.observe(w); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
    // Po přepnutí varianty se panel překreslí — nové slidery je potřeba znovu odchytit
    document.addEventListener('tk:product-tabs-updated', observeAll);
  })();

  /* Feature image lightbox — dark transparent backdrop, view-transition zoom from source */
  (function () {
    if (window.__tkFeatureLightboxInit) return;
    window.__tkFeatureLightboxInit = true;

    var dialog = document.querySelector('[data-tk-feature-lightbox]');
    if (!dialog) return;
    var img = dialog.querySelector('.tk-feature-lightbox__img');
    var closeBtn = dialog.querySelector('[data-tk-feature-lightbox-close]');
    var savedScrollY = 0;
    var sourceEl = null;
    var TRANSITION_NAME = 'tk-feature-zoom';
    var supportsVT = typeof document.startViewTransition === 'function';
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function lockScroll() {
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      // Restore scroll first via direct scrollTop, before body styles flip back
      // (otherwise body briefly goes to scroll 0 and any smooth-scroll CSS
      // animates the bounce back to savedScrollY → visible scroll glitch).
      var prevHtmlScroll = document.documentElement.style.scrollBehavior;
      var prevBodyScroll = document.body.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.scrollBehavior = 'auto';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      try {
        window.scrollTo({ top: savedScrollY, left: 0, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(0, savedScrollY);
      }
      // Restore on next frame so we don't leak the override
      requestAnimationFrame(function () {
        document.documentElement.style.scrollBehavior = prevHtmlScroll;
        document.body.style.scrollBehavior = prevBodyScroll;
      });
    }

    function showOpenState() {
      // Show in next frame so the transition kicks in from initial state
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.classList.add('is-open');
        });
      });
    }

    function open(src, alt, src2x, trigger) {
      if (!src) return;
      sourceEl = trigger || null;
      img.src = src;
      if (src2x) img.setAttribute('srcset', src + ' 1x, ' + src2x + ' 2x');
      else img.removeAttribute('srcset');
      img.alt = alt || '';
      // Show spinner until image finishes loading
      dialog.classList.add('is-loading');
      var clearLoading = function () {
        dialog.classList.remove('is-loading');
        img.removeEventListener('load', clearLoading);
        img.removeEventListener('error', clearLoading);
      };
      if (img.complete && img.naturalWidth > 0) {
        clearLoading();
      } else {
        img.addEventListener('load', clearLoading);
        img.addEventListener('error', clearLoading);
      }
      lockScroll();

      var doOpen = function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        showOpenState();
      };

      if (supportsVT && !prefersReduced && sourceEl) {
        sourceEl.style.setProperty('view-transition-name', TRANSITION_NAME);
        img.style.setProperty('view-transition-name', TRANSITION_NAME);
        var transition = document.startViewTransition(doOpen);
        transition.finished.finally(function () {
          if (sourceEl) sourceEl.style.removeProperty('view-transition-name');
          img.style.removeProperty('view-transition-name');
        });
      } else {
        doOpen();
      }
    }

    function close() {
      var doClose = function () {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        dialog.classList.remove('is-open');
        unlockScroll();
        // Defer src clear so view-transition snapshot still has content
        setTimeout(function () { img.removeAttribute('src'); img.removeAttribute('srcset'); }, 50);
      };

      if (supportsVT && !prefersReduced && sourceEl) {
        sourceEl.style.setProperty('view-transition-name', TRANSITION_NAME);
        img.style.setProperty('view-transition-name', TRANSITION_NAME);
        var transition = document.startViewTransition(doClose);
        transition.finished.finally(function () {
          if (sourceEl) sourceEl.style.removeProperty('view-transition-name');
          img.style.removeProperty('view-transition-name');
          sourceEl = null;
        });
      } else {
        // Fade out via CSS, then close
        dialog.classList.remove('is-open');
        setTimeout(doClose, 240);
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-tk-feature-zoom]');
      if (trigger) {
        e.preventDefault();
        var src = trigger.getAttribute('data-tk-feature-zoom');
        var src2x = trigger.getAttribute('data-tk-feature-zoom-2x');
        var inner = trigger.querySelector('img');
        open(src, inner ? inner.alt : '', src2x, trigger);
        return;
      }
      // Backdrop click closes (dialog itself is the click target since img is centered)
      if (e.target === dialog) {
        close();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    // Esc key triggers native dialog 'cancel' event before 'close'
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });
  })();

  /* Shorts jedou s controls=0 (viz snippets/tk-short-embed.liquid). Tlačítko v rohu
     ovládání vrátí — přeložíme iframe s controls=1 od času, kde uživatel je.
     Čas známe díky enablejsapi=1: YouTube posílá infoDelivery zprávy, jakmile mu
     pošleme handshake {"event":"listening"}. POUZE posloucháme — playVideo přes
     postMessage by na mobilech spadlo na politiku „gesto musí být uvnitř iframu". */
  (function () {
    if (window.__tkShortControlsInit) return;
    window.__tkShortControlsInit = true;

    var YT_ORIGIN = 'https://www.youtube.com';
    var times = new WeakMap();
    var states = new WeakMap();
    // Štít smí existovat jen tam, kde vůbec hrozí hover chrome — na dotyku by jen
    // překážel a přehrání přes postMessage tam blokuje autoplay politika.
    var hasHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function post(frame, msg) {
      if (!frame.contentWindow) return;
      try {
        frame.contentWindow.postMessage(JSON.stringify(msg), YT_ORIGIN);
      } catch (e) {}
    }

    // Handshake se musí OPAKOVAT: když dorazí dřív, než je přehrávač inicializovaný
    // (typicky u loading="lazy" iframu), YouTube ho zahodí a infoDelivery už nepošle
    // nikdy — štít by pak zůstal vypnutý a chrome by se kreslil dál.
    var reported = new WeakSet();
    var pingTimer = null;

    function handshake(frame) {
      post(frame, { event: 'listening', id: 1, channel: 'widget' });
    }

    function pingLoop() {
      if (pingTimer) return;
      var ticks = 0;
      pingTimer = setInterval(function () {
        ticks++;
        var frames = document.querySelectorAll('iframe[data-tk-short]');
        var pending = 0;
        for (var i = 0; i < frames.length; i++) {
          if (reported.has(frames[i])) continue;
          pending++;
          handshake(frames[i]);
        }
        if (!pending || ticks > 40) {
          clearInterval(pingTimer);
          pingTimer = null;
        }
      }, 600);
    }

    function shieldOf(frame) {
      return frame.parentElement ? frame.parentElement.querySelector('[data-tk-short-shield]') : null;
    }

    function bind(root) {
      var frames = (root || document).querySelectorAll('iframe[data-tk-short]:not([data-tk-short-bound])');
      for (var i = 0; i < frames.length; i++) {
        (function (frame) {
          frame.setAttribute('data-tk-short-bound', '1');
          frame.addEventListener('load', function () { handshake(frame); });
          handshake(frame);
          // Štít nasazujeme HNED, ne až po startu přehrávání: kdyby první klik
          // dopadl na YouTube, nastavil by si hover stav a chrome by pak držel
          // napořád — o odchodu myši se totiž přes štít už nikdy nedozví.
          var shield = shieldOf(frame);
          if (shield && hasHover) shield.hidden = false;
        })(frames[i]);
      }
      if (frames.length) pingLoop();
    }

    // Iframy v neaktivním tabu se načtou až při přepnutí — po jakékoli interakci
    // pingLoop nastartuj znovu (sám se zastavil, když nebylo co řešit). Klik přímo
    // do iframu se v rodičovském dokumentu neobjeví, ale přepnutí tabu ano.
    document.addEventListener('pointerdown', function () { pingLoop(); });

    window.addEventListener('message', function (e) {
      if (e.origin !== YT_ORIGIN) return;
      var data;
      try { data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }
      if (!data || !data.info) return;
      var frames = document.querySelectorAll('iframe[data-tk-short]');
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].contentWindow !== e.source) continue;
        var frame = frames[i];
        reported.add(frame);
        if (typeof data.info.currentTime === 'number') times.set(frame, data.info.currentTime);
        if (typeof data.info.playerState === 'number') states.set(frame, data.info.playerState);
        return;
      }
    });

    document.addEventListener('click', function (e) {
      var shield = e.target.closest ? e.target.closest('[data-tk-short-shield]') : null;
      if (!shield) return;
      var frame = shield.parentElement && shield.parentElement.querySelector('iframe[data-tk-short]');
      if (!frame) return;
      var playing = states.get(frame) === 1;
      post(frame, { event: 'command', func: playing ? 'pauseVideo' : 'playVideo', args: [] });
      if (playing) return;
      // Přehrání přes postMessage smí projít jen díky allow="autoplay" na iframu,
      // které mu deleguje oprávnění z gesta na stránce. Kdyby to prohlížeč přesto
      // odmítl, štít sundáme, ať další klik dopadne přímo na YouTube a uživatel
      // nezůstane viset u videa, které nejde spustit.
      setTimeout(function () {
        if (states.get(frame) !== 1) shield.hidden = true;
      }, 900);
    });

    // Delegace na dokumentu — přežije morph tabů po změně varianty
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-tk-short-controls]') : null;
      if (!btn) return;
      var id = btn.getAttribute('data-tk-short-controls');
      var frame = btn.parentElement && btn.parentElement.querySelector('iframe[data-tk-short]');
      if (!id || !frame) return;
      var start = Math.max(0, Math.floor(times.get(frame) || 0));
      // Se zapnutým ovládáním musí myš na YouTube zase dosáhnout
      var shield = shieldOf(frame);
      if (shield) shield.remove();
      frame.removeAttribute('data-tk-short');
      frame.src =
        'https://www.youtube.com/embed/' + encodeURIComponent(id) +
        '?controls=1&rel=0&playsinline=1&autoplay=1&start=' + start;
      btn.remove();
    });

    bind();
    // Nové iframy přibývají při morphu tabů (změna varianty) i při lazy renderu.
    // Observer je na celém dokumentu, takže bind() jede přes rAF — jinak by běžel
    // při každé mutaci od Judge.me / cart draweru / atd.
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          bind();
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { bind(); });
  })();
